import { useSearchCondition } from '@/providers/SearchConditionProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useTeamSalesOrderPhases } from '@/hooks/api/0250_team_sales_order_phases';
import { useBusinessPartners } from '@/hooks/api/0430_business_partners';
import { useProducts } from '@/hooks/api/0390_products';

export const SalesOrderSearchConditionTags = () => {
  const { salesOrderSearchCondition: searchCondition } = useSearchCondition();
  const isConditionExist = Object.values(searchCondition)
    .flat()
    .some((v) => v);

  if (!isConditionExist) return <></>;

  const { _w_, _t_ } = useCurrentTeamMember();
  const { data: phases } = useTeamSalesOrderPhases({ identifier: _w_!.identifier, team_id: _t_!.id });
  const { data: businessPartners } = useBusinessPartners({ identifier: _w_!.identifier, page: 1, per: 1000 });
  const { data: products } = useProducts({ identifier: _w_!.identifier });

  return (
    <div className="d-flex mb-4 align-items-center flex-wrap">
      {searchCondition.my_project && (
        <span className="badge rounded-pill badge-info mx-1 my-1">参加済プロジェクトのみ表示</span>
      )}

      {phases &&
        phases
          .filter((d) => searchCondition.team_sales_order_phase_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}

      {_t_!.team_members
        .filter((d) => searchCondition.user_ids.includes(d.user.id))
        .map((d) => (
          <span key={`user-tag-${d.user.id}`} className="badge rounded-pill badge-info mx-1 my-1">
            {d.user.user_account.name}
          </span>
        ))}

      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.business_partner_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}

      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.agency_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}

      {products &&
        products
          .filter((d) => searchCondition.product_ids.includes(d.id))
          .map((d) => (
            <span key={`product-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {searchCondition.archived ? (
        <span className="badge rounded-pill badge-primary mx-1 my-1">アーカイブ済プロジェクトを含める</span>
      ) : (
        <span className="badge rounded-pill badge-secondary mx-1 my-1">アーカイブ済プロジェクトを含めない</span>
      )}
    </div>
  );
};
